import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";

import { api } from "../lib/api.ts";
import { logout } from "../lib/auth.ts";

export function Layout() {
	const navItem =
		"px-3 py-2 rounded-md text-sm font-medium transition-colors text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800/60";
	const navItemActive = "bg-zinc-800 text-zinc-100";

	// Worker deploy SHA — read once on mount from /api/agents/status. Falls back
	// to undefined on older Workers; banner just hides itself in that case.
	const [deploySha, setDeploySha] = useState<string | undefined>(undefined);
	useEffect(() => {
		api
			.listAllAgentStatuses()
			.then((r) => setDeploySha(r.deploySha))
			.catch(() => undefined);
	}, []);

	const copySha = async () => {
		if (deploySha && deploySha !== "dev") {
			try {
				await navigator.clipboard.writeText(deploySha);
			} catch {
				/* clipboard might be blocked in some contexts — silent */
			}
		}
	};

	return (
		<div className="flex h-full">
			<aside className="w-56 border-r border-zinc-800 bg-terminal/50 flex flex-col">
				<div className="px-4 py-5 border-b border-zinc-800">
					<div className="text-base font-semibold">G1 Manager</div>
					<div className="text-xs text-zinc-500">agent.g1.group</div>
				</div>
				<nav className="flex-1 p-3 space-y-1">
					<NavLink end to="/" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Chat
					</NavLink>
					<NavLink to="/digests" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Digests
					</NavLink>
					<NavLink to="/businesses" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Businesses
					</NavLink>
					<NavLink to="/agents" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Agents
					</NavLink>
					<NavLink to="/hosts" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Hosts
					</NavLink>
					<NavLink to="/skills" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Skills
					</NavLink>
					<NavLink to="/tools" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Tools
					</NavLink>
					<NavLink to="/decisions" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Decisions
					</NavLink>
					<NavLink to="/audit" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Audit log
					</NavLink>
					<NavLink to="/settings" className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""} block`}>
						Settings
					</NavLink>
				</nav>
				<button
					type="button"
					onClick={() => void logout()}
					className="mx-3 mb-3 px-3 py-2 rounded-md text-sm text-zinc-500 hover:text-zinc-100 hover:bg-zinc-800/60 text-left"
				>
					Sign out
				</button>
				{deploySha && deploySha !== "dev" && (
					<button
						type="button"
						onClick={() => void copySha()}
						title="Worker bundle git SHA — click to copy"
						className="mx-3 mb-3 text-[10px] text-zinc-600 hover:text-zinc-400 font-mono text-left"
					>
						agent.g1.group · {deploySha}
					</button>
				)}
			</aside>
			<main className="flex-1 overflow-y-auto">
				<Outlet />
			</main>
		</div>
	);
}
